import { get } from '@/utils/request';

const url = 'course-reservation-records';

export function index(data) {
  return get({
    url,
    data,
  });
}
